import { render, staticRenderFns } from "./HeightTransition.vue?vue&type=template&id=3973f916&scoped=true"
import script from "./HeightTransition.vue?vue&type=script&lang=js"
export * from "./HeightTransition.vue?vue&type=script&lang=js"
import style0 from "./HeightTransition.vue?vue&type=style&index=0&id=3973f916&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3973f916",
  null
  
)

export default component.exports